@file:OptIn(InternalResourceApi::class)

package cmp.navigation.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/cmp.navigation.generated.resources/"

public val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 24),
      ))
    }

public val Res.string.back: StringResource by lazy {
      StringResource("string:back", "back", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 35, 20),
      ))
    }

public val Res.string.dashboard: StringResource by lazy {
      StringResource("string:dashboard", "dashboard", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 56, 29),
      ))
    }

public val Res.string.error_generic: StringResource by lazy {
      StringResource("string:error_generic", "error_generic", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 86, 45),
      ))
    }

public val Res.string.home: StringResource by lazy {
      StringResource("string:home", "home", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 132, 20),
      ))
    }

public val Res.string.loading: StringResource by lazy {
      StringResource("string:loading", "loading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 153, 31),
      ))
    }

public val Res.string.not_connected: StringResource by lazy {
      StringResource("string:not_connected", "not_connected", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 185, 61),
      ))
    }

public val Res.string.notification_permission_description: StringResource by lazy {
      StringResource("string:notification_permission_description", "notification_permission_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 247, 167),
      ))
    }

public val Res.string.notification_permission_enable: StringResource by lazy {
      StringResource("string:notification_permission_enable", "notification_permission_enable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 415, 50),
      ))
    }

public val Res.string.notification_permission_not_now: StringResource by lazy {
      StringResource("string:notification_permission_not_now", "notification_permission_not_now", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 466, 51),
      ))
    }

public val Res.string.notification_permission_title: StringResource by lazy {
      StringResource("string:notification_permission_title", "notification_permission_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 518, 73),
      ))
    }

public val Res.string.patients: StringResource by lazy {
      StringResource("string:patients", "patients", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 592, 28),
      ))
    }

public val Res.string.payments: StringResource by lazy {
      StringResource("string:payments", "payments", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 621, 24),
      ))
    }

public val Res.string.profile: StringResource by lazy {
      StringResource("string:profile", "profile", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 646, 23),
      ))
    }

public val Res.string.saving: StringResource by lazy {
      StringResource("string:saving", "saving", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 670, 30),
      ))
    }

public val Res.string.sessions: StringResource by lazy {
      StringResource("string:sessions", "sessions", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 701, 28),
      ))
    }

public val Res.string.settings: StringResource by lazy {
      StringResource("string:settings", "settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 730, 36),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("app_name", Res.string.app_name)
  map.put("back", Res.string.back)
  map.put("dashboard", Res.string.dashboard)
  map.put("error_generic", Res.string.error_generic)
  map.put("home", Res.string.home)
  map.put("loading", Res.string.loading)
  map.put("not_connected", Res.string.not_connected)
  map.put("notification_permission_description", Res.string.notification_permission_description)
  map.put("notification_permission_enable", Res.string.notification_permission_enable)
  map.put("notification_permission_not_now", Res.string.notification_permission_not_now)
  map.put("notification_permission_title", Res.string.notification_permission_title)
  map.put("patients", Res.string.patients)
  map.put("payments", Res.string.payments)
  map.put("profile", Res.string.profile)
  map.put("saving", Res.string.saving)
  map.put("sessions", Res.string.sessions)
  map.put("settings", Res.string.settings)
}
